<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单标题">
                <a-input v-model="queryParam.title" placeholder="请输入招工标题" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单编号">
                <a-input v-model="queryParam.orderNo" placeholder="请输入订单编号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="异常类型">
                <a-select v-model="queryParam.abnormalType" placeholder="请选择异常类型" allow-clear>
                  <a-select-option :value="1">缺上工卡</a-select-option>
                  <a-select-option :value="2">缺下工卡</a-select-option>
                  <a-select-option :value="3">雇主未付款</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="处理状态">
                <a-select v-model="queryParam.isResolved" placeholder="请选择处理状态" allow-clear>
                  <a-select-option :value="0">未处理</a-select-option>
                  <a-select-option :value="1">已处理</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1700 }"
        class="abnormal-table"
      >
        <!-- 订单状态 -->
        <span slot="orderStatus" slot-scope="text, record">
          <a-tag v-if="record.orderStatus === -1" color="default">其他</a-tag>
          <a-tag v-else-if="record.orderStatus === 0" color="blue">接单中</a-tag>
          <a-tag v-else-if="record.orderStatus === 1" color="cyan">服务中</a-tag>
          <a-tag v-else-if="record.orderStatus === 3" color="orange">售后中</a-tag>
          <a-tag v-else-if="record.orderStatus === 5" color="purple">待服务</a-tag>
          <span v-else>-</span>
        </span>
        <!-- 异常类型 -->
        <span slot="abnormalType" slot-scope="text, record">
          <a-tag v-if="record.abnormalType === 1" color="orange">缺上工卡</a-tag>
          <a-tag v-else-if="record.abnormalType === 2" color="volcano">缺下工卡</a-tag>
          <a-tag v-else-if="record.abnormalType === 3" color="red">雇主未付款</a-tag>
          <span v-else>-</span>
        </span>
        <!-- 通知状态 -->
        <span slot="isNotified" slot-scope="text, record">
          <a-badge v-if="record.isNotified === 1" status="success" text="已通知" />
          <a-badge v-else status="default" text="未通知" />
        </span>
        <!-- 处理状态 -->
        <span slot="isResolved" slot-scope="text, record">
          <a-badge v-if="record.isResolved === 1" status="success" text="已处理" />
          <a-badge v-else status="processing" text="待处理" />
        </span>
        <!-- 时间格式化 -->
        <span slot="workEndTime" slot-scope="text, record">
          {{ parseTime(record.workEndTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <!-- 操作 -->
        <span slot="operation" slot-scope="text, record">
          <a @click="showDetail(record)">
            <a-icon type="info-circle" />详情
          </a>
          <a-divider type="vertical" v-hasPermi="['order:abnormal:resolve']" v-if="record.isResolved !== 1" />
          <a
            v-hasPermi="['order:abnormal:resolve']"
            v-if="record.isResolved !== 1"
            :disabled="resolveSubmittingId === record.id"
            @click="handleResolve(record)"
          >
            <a-icon type="check" />标记已处理
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />

      <!-- 详情弹窗 -->
      <a-modal
        title="异常订单详情"
        :visible="detailVisible"
        :footer="null"
        width="720px"
        @cancel="detailVisible = false"
      >
        <a-spin :spinning="detailLoading">
          <template v-if="currentRecord">
            <a-descriptions :column="2" bordered size="small">
              <a-descriptions-item label="订单标题" :span="2">
                {{ currentRecord.orderTitle || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="订单编号">
                {{ currentRecord.orderNo || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="雇主">
                {{ currentRecord.userName || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="订单状态">
                <a-tag v-if="currentRecord.orderStatus === -1" color="default">其他</a-tag>
                <a-tag v-else-if="currentRecord.orderStatus === 0" color="blue">接单中</a-tag>
                <a-tag v-else-if="currentRecord.orderStatus === 1" color="cyan">服务中</a-tag>
                <a-tag v-else-if="currentRecord.orderStatus === 3" color="orange">售后中</a-tag>
                <a-tag v-else-if="currentRecord.orderStatus === 5" color="purple">待服务</a-tag>
                <span v-else>-</span>
              </a-descriptions-item>
              <a-descriptions-item label="计价方式">
                {{ currentRecord.pricingMethodDesc || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="异常类型">
                <a-tag v-if="currentRecord.abnormalType === 1" color="orange">缺上工卡</a-tag>
                <a-tag v-else-if="currentRecord.abnormalType === 2" color="volcano">缺下工卡</a-tag>
                <a-tag v-else-if="currentRecord.abnormalType === 3" color="red">雇主未付款</a-tag>
              </a-descriptions-item>
              <a-descriptions-item label="异常原因" :span="2">
                {{ currentRecord.abnormalReason || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="订单结束时间">
                {{ parseTime(currentRecord.workEndTime) }}
              </a-descriptions-item>
              <a-descriptions-item label="异常检测时间">
                {{ parseTime(currentRecord.createTime) }}
              </a-descriptions-item>
              <a-descriptions-item label="通知状态">
                <a-badge v-if="currentRecord.isNotified === 1" status="success" text="已通知" />
                <a-badge v-else status="default" text="未通知" />
              </a-descriptions-item>
              <a-descriptions-item label="处理状态">
                <a-badge v-if="currentRecord.isResolved === 1" status="success" text="已处理" />
                <a-badge v-else status="processing" text="待处理" />
              </a-descriptions-item>
            </a-descriptions>

            <!-- 异常详情JSON展示 -->
            <template v-if="abnormalDetailParsed && abnormalDetailParsed.length > 0">
              <a-divider orientation="left" style="margin-top: 24px">异常详情</a-divider>
              <a-table
                v-if="currentRecord.abnormalType === 1 || currentRecord.abnormalType === 2"
                :columns="detailColumns"
                :data-source="abnormalDetailParsed"
                :pagination="false"
                size="small"
                rowKey="masterOrderId"
              >
                <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
              </a-table>
              <a-descriptions
                v-else-if="currentRecord.abnormalType === 3"
                :column="1"
                bordered
                size="small"
              >
                <a-descriptions-item
                  v-for="(item, idx) in abnormalDetailParsed"
                  :key="idx"
                  :label="item.type"
                >
                  {{ item.money != null ? '¥' + Number(item.money).toFixed(2) : '-' }}
                </a-descriptions-item>
              </a-descriptions>
            </template>
          </template>
          <a-empty v-else description="暂无数据" />
        </a-spin>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageOrderAbnormal, resolveOrderAbnormal } from '@/api/order/orderAbnormal'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'OrderAbnormal',
  mixins: [tableMixin],
  data () {
    return {
      loading: false,
      list: [],
      total: 0,
      queryParam: {
        title: undefined,
        orderNo: undefined,
        abnormalType: undefined,
        isResolved: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: 70,
          align: 'center',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '订单标题',
          dataIndex: 'orderTitle',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '雇主',
          dataIndex: 'userName',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'orderStatus' }
        },
        {
          title: '异常类型',
          dataIndex: 'abnormalType',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'abnormalType' }
        },
        {
          title: '异常原因',
          dataIndex: 'abnormalReason',
          width: 200,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '通知状态',
          dataIndex: 'isNotified',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'isNotified' }
        },
        {
          title: '处理状态',
          dataIndex: 'isResolved',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'isResolved' }
        },
        {
          title: '订单结束时间',
          dataIndex: 'workEndTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'workEndTime' }
        },
        {
          title: '检测时间',
          dataIndex: 'createTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 160,
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      // 详情弹窗
      detailVisible: false,
      detailLoading: false,
      currentRecord: null,
      // 标记已处理中
      resolveSubmittingId: null,
      // 异常详情-缺卡师傅列表列定义
      detailColumns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: 60,
          align: 'center',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '师傅订单ID',
          dataIndex: 'masterOrderId',
          align: 'center'
        },
        {
          title: '师傅用户ID',
          dataIndex: 'userId',
          align: 'center'
        }
      ]
    }
  },
  computed: {
    /** 将 abnormalDetail JSON 字符串解析为数组 */
    abnormalDetailParsed () {
      if (!this.currentRecord || !this.currentRecord.abnormalDetail) {
        return []
      }
      try {
        const parsed = JSON.parse(this.currentRecord.abnormalDetail)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    /** 查询异常订单列表 */
    getList () {
      this.loading = true
      pageOrderAbnormal(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    /** 搜索 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },

    /** 重置 */
    resetQuery () {
      this.queryParam = {
        title: undefined,
        orderNo: undefined,
        abnormalType: undefined,
        isResolved: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },

    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    /** 查看详情 */
    showDetail (record) {
      this.currentRecord = record
      this.detailVisible = true
    },

    /** 标记已处理 */
    handleResolve (record) {
      const that = this
      this.$confirm({
        title: '确认标记已处理？',
        content: `确定将订单「${record.orderTitle}」的「${this.getAbnormalTypeText(record.abnormalType)}」异常标记为已处理吗？`,
        onOk () {
          that.resolveSubmittingId = record.id
          return resolveOrderAbnormal({ id: record.id }).then(() => {
            that.$message.success('已处理', 3)
            that.getList()
          }).finally(() => {
            that.resolveSubmittingId = null
          })
        }
      })
    },

    getAbnormalTypeText (type) {
      const map = { 1: '缺上工卡', 2: '缺下工卡', 3: '雇主未付款' }
      return map[type] || '未知'
    }
  }
}
</script>

<style lang="less" scoped>
.abnormal-table {
  /deep/ .ant-table-thead > tr > th {
    padding: 16px;
    font-weight: 500;
  }

  /deep/ .ant-table-tbody > tr > td {
    padding: 16px;
  }

  /deep/ .ant-table-tbody > tr:hover > td {
    background: #f5f5f5;
  }

  /deep/ .ant-table-tbody > tr > td .ant-divider {
    margin: 0 8px;
  }

  /deep/ .ant-table-tbody > tr > td a {
    margin: 0 4px;
  }
}
</style>
